/**
 * Admin Popup Service
 * Handles all page popup-related admin API calls
 */

import { getApi, postApi, updateApi, deleteApi } from '../adminApi';

/**
 * Get all page popups
 * @param {Object} params - Query parameters
 * @returns {Promise}
 */
export const getPagePopups = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return getApi(`page-popups?${queryParams}`);
};

/**
 * Get page popup by ID
 * @param {string} popupId - Popup ID
 * @returns {Promise}
 */
export const getPagePopupById = async (popupId) => {
  return getApi(`page-popups/${popupId}`);
};

/**
 * Create a new page popup
 * @param {Object} data - Popup data
 * @returns {Promise}
 */
export const createPagePopup = async (data) => {
  return postApi('page-popups', data);
};

/**
 * Update a page popup
 * @param {string} popupId - Popup ID
 * @param {Object} data - Update data
 * @returns {Promise}
 */
export const updatePagePopup = async (popupId, data) => {
  return updateApi(`page-popups/${popupId}`, data);
};

/**
 * Delete a page popup
 * @param {string} popupId - Popup ID
 * @returns {Promise}
 */
export const deletePagePopup = async (popupId) => {
  return deleteApi(`page-popups/${popupId}`);
};

